export const GET_AWS_ACC = 'get_aws_acc';
export const GET_AWS_ACC_SUCCESSFUL = 'get_aws_acc_successful';
export const GET_AWS_ACC_FAILED = 'get_aws_acc_failed';

export const POST_AWS_ACC = 'post_aws_acc';
export const POST_AWS_ACC_SUCCESSFUL = 'post_aws_acc_successful';
export const POST_AWS_ACC_FAILED = 'post_aws_acc_failed'; 

export const CLEAR_ALL_AWS_ACC_MESSAGES = "clear_all_aws_acc_messages";
export const CLEAR_ALL_AWS_ACC_MESSAGES_SUCCESSFUL = "clear_all_aws_acc_messages_successful";